import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { authApi } from './shared/lib/api'
import { useAuthStore, isAdmin } from './shared/store/authStore'

const DEMO_ACCOUNTS = [
  { label: 'Admin', mobile: '9000000000', role: 'admin', color: 'bg-brand-600', desc: 'Full web panel access' },
  { label: 'Metallic Master', mobile: '9876543210', role: 'metallic_master', color: 'bg-slate-700', desc: 'Cutting & Bobbin flows' },
  { label: 'Loading Supervisor', mobile: '9876543211', role: 'loading_supervisor', color: 'bg-teal-600', desc: 'Spindle, Boiling, Cone' },
]

export default function LoginPage() {
  const [mobile, setMobile] = useState('')
  const [pin, setPin] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const { login } = useAuthStore()
  const navigate = useNavigate()

  const doLogin = (mobileNum) => {
    setLoading(true)
    setError('')
    authApi.login(mobileNum, '0000')
      .then((res) => {
        const { user, token } = res.data.data
        login(user, token)
        navigate(isAdmin(user.role) ? '/admin' : '/app/dashboard', { replace: true })
      })
      .catch((err) => {
        setError(err?.response?.data?.message || 'Mobile number not found')
        setLoading(false)
      })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    if (!mobile) return setError('Enter your mobile number')
    doLogin(mobile.replace(/\s/g, ''))
  }

  return (
    <div className="min-h-screen bg-surface-page flex items-center justify-center p-4">
      <div className="w-full max-w-sm">

        {/* Logo */}
        <div className="flex flex-col items-center mb-8">
          <div className="w-16 h-16 bg-brand-600 rounded-2xl flex items-center justify-center mb-4">
            <span className="text-white text-2xl font-bold font-mono">JT</span>
          </div>
          <h1 className="text-xl font-semibold text-gray-800">Jaritex Production</h1>
          <p className="text-sm text-gray-400 mt-1">Sign in to your account</p>
        </div>

        {/* Demo quick-access */}
        <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider text-center mb-3">
          Quick Demo Access
        </p>
        <div className="flex flex-col gap-2 mb-5">
          {DEMO_ACCOUNTS.map((a) => (
            <button
              key={a.role}
              onClick={() => doLogin(a.mobile)}
              disabled={loading}
              className={`${a.color} text-white rounded-xl px-4 py-3 flex items-center justify-between hover:opacity-90 transition-opacity disabled:opacity-60`}
            >
              <div className="text-left">
                <p className="text-sm font-semibold">{a.label}</p>
                <p className="text-xs opacity-70">{a.desc}</p>
              </div>
              <svg className="opacity-70 flex-shrink-0" width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
          ))}
        </div>

        {/* Divider */}
        <div className="flex items-center gap-3 mb-5">
          <div className="flex-1 h-px bg-gray-200" />
          <span className="text-xs text-gray-400">or sign in manually</span>
          <div className="flex-1 h-px bg-gray-200" />
        </div>

        {/* Manual form */}
        <form onSubmit={handleSubmit} className="bg-white rounded-2xl border border-gray-100 p-5 space-y-4 shadow-sm">
          <div>
            <label className="form-label">Mobile number</label>
            <input className="form-input text-base py-2.5" type="tel" inputMode="tel" placeholder="10-digit mobile" value={mobile} onChange={(e) => setMobile(e.target.value)} />
          </div>
          <div>
            <label className="form-label">PIN</label>
            <input className="form-input text-lg py-2.5 tracking-widest" type="password" inputMode="numeric" placeholder="••••" maxLength={4} value={pin} onChange={(e) => setPin(e.target.value)} />
            <p className="text-xs text-gray-400 mt-1">Any PIN works in demo mode</p>
          </div>
          {error && <div className="bg-red-50 border border-red-200 rounded-lg px-3 py-2 text-sm text-red-700">{error}</div>}
          <button type="submit" disabled={loading} className="big-btn-primary disabled:opacity-50">
            {loading ? 'Signing in…' : 'Sign in'}
          </button>
        </form>

        {/* Mobile reference */}
        <div className="mt-4 bg-white rounded-xl border border-gray-100 p-4">
          <p className="text-xs font-semibold text-gray-500 mb-2">Demo mobile numbers</p>
          <div className="space-y-1">
            {DEMO_ACCOUNTS.map(a => (
              <div key={a.mobile} className="flex justify-between text-xs">
                <span className="text-gray-500">{a.label}</span>
                <button onClick={() => setMobile(a.mobile)} className="font-mono text-brand-600 hover:underline">{a.mobile}</button>
              </div>
            ))}
          </div>
        </div>

      </div>
    </div>
  )
}
